const TimeRange = {
    shortcuts: [{
        text: '昨天',
        onClick (picker) {
            const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1);
            const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
            start.setTime(start.getTime() - 3600 * 1000 * 24);
            end.setTime(end.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近3天',
        onClick (picker) {
            const end = new Date();
            const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 2);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近7天',
        onClick (picker) {
            const end = new Date();
            const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '本周',
        onClick (picker) {
            const end = new Date();
            const start = new Date();
            var thisDay = start.getDay();
            var thisDate = start.getDate();
            if (thisDay != 0) {
                start.setDate(thisDate - thisDay + 1);
            }
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '上周',
        onClick (picker) {
            const oDate = new Date(new Date(new Date().toLocaleDateString()));
            oDate.setTime(oDate.getTime() - 3600 * 1000 * 24 * 7);

            var day = oDate.getDay()

            var start = new Date(),
                end = new Date();
            if (day == 0) {
                start.setDate(oDate.getDate() + 1);
                end.setDate(oDate.getDate() + 7);
            } else {
                start.setTime(oDate.getTime() - 3600 * 1000 * 24 * (day - 1));
                end.setTime(oDate.getTime() + 3600 * 1000 * 24 * (8 - day) - 1);
            }

            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近14天',
        onClick (picker) {
            const end = new Date();
            const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近30天',
        onClick (picker) {
            const end = new Date();
            const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近60天',
        onClick (picker) {
            const end = new Date();
            const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 60);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近90天',
        onClick (picker) {
            const end = new Date();
            const start = new Date(new Date(new Date().toLocaleDateString()).getTime());
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '本月',
        onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setDate(1);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '上个月',
        onClick (picker) {
            const oDate = new Date();
            var year = oDate.getFullYear();
            var month = oDate.getMonth();
            var start, end;
            if (month == 0) {
                year--
                start = new Date(year, 11, 1)
                end = new Date(year, 11, 31)
            } else {
                start = new Date(year, month - 1, 1)
                end = new Date(year, month, 0);
            }

            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '三个月',
        onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 3);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '半年',
        onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '一年',
        onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 12);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '两年',
        onClick (picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 24);
            picker.$emit('pick', [start, end]);
        }
    }],
    // disabledDate (time) {
    //     if (
    //         time.getTime() > Date.now()
    //     ) {
    //         return true;
    //     } else {
    //         return false;
    //     }
    // }
}
export default TimeRange;